import { busyWhile } from "lib/@components/busy/busy-while"
import { confirm } from "lib/@dialogs/confirm"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { removeSkillMapTrade } from "routes/skill-mapper/controller/remove-skill-map-trade"
import { removeTradeMessage } from "./remove-trade-message"

/**
 * Ask, then remove a trade. The server prunes every line referencing the trade (keeping
 * the line records and their task counts, so skills become unmapped rather than deleted)
 * and removes its schedule assignments. Conditional rules sending work to it are dropped
 * too, so conditionalRuleCount (skills with such rules) is named in the warning.
 *
 * @returns {Promise<boolean>} Whether the trade was removed
 */
export async function confirmAndRemoveTrade({
    skillMapId,
    tradeId,
    tradeName,
    skillCount,
    assignmentCount,
    conditionalRuleCount,
}) {
    // The button names the action rather than "Ok", since it also unmaps the trade's skills
    const ok = await confirm(
        removeTradeMessage({ tradeName, skillCount, assignmentCount, conditionalRuleCount }),
        "Remove Trade",
        undefined,
        "Remove trade",
        { okColor: "error" }
    )
    if (!ok) return false
    await busyWhile(() => removeSkillMapTrade({ skillMapId, tradeId }), "Removing trade...")
    successSnackbar(`Trade "${tradeName}" removed, skills are now unmapped`)
    return true
}
